var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.loading } },
    [
      _vm.creditCardRequired
        ? _c("CreditCardNeeded", {
            on: {
              close: function ($event) {
                _vm.creditCardRequired = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cancelPlanModal
        ? _c("CancelPlanModal", {
            on: {
              confirm: function ($event) {
                return _vm.unsubscribe(_vm.cancelPlanModal)
              },
              reject: function ($event) {
                _vm.cancelPlanModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.subscribePlanModal
        ? _c("CreatePlanModal", {
            attrs: { planPeriod: _vm.period, plan: _vm.subscribePlanModal },
            on: {
              confirm: function ($event) {
                return _vm.subscribe(_vm.subscribePlanModal)
              },
              reject: function ($event) {
                _vm.subscribePlanModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showWarn
        ? _c(
            "DowngradeWarn",
            {
              on: {
                close: function ($event) {
                  _vm.showWarn = null
                },
                forward: _vm.forwardPage,
              },
            },
            [
              _vm.showWarn == "supsis"
                ? [
                    _vm._v(
                      "\n            Paketiniz düşürülemiyor. Paketinizi düşürmek için lütfen Temsilcilerinizden bir kaçını siliniz veya\n            devredışı bırakınız.\n        "
                    ),
                  ]
                : _vm.showWarn == "whatsapp"
                ? [
                    _vm._v(
                      "\n            Paketiniz düşürülemiyor. Paketinizi düşürmek için lütfen Whatsapp Kanalarınızdan bir kaçını siliniz.\n        "
                    ),
                  ]
                : _vm.showWarn == "whatsapp-business"
                ? [
                    _vm._v(
                      "\n            Paketiniz düşürülemiyor. Paketinizi düşürmek için lütfen Whatsapp Business Kanalarınızdan bir kaçını\n            siliniz.\n        "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.chatbotExtraPackageModal
        ? _c("ExtraPlanModal", {
            attrs: { period: _vm.period },
            on: {
              confirm: _vm.subscribeExtra,
              close: function ($event) {
                _vm.chatbotExtraPackageModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "billing-plans" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.type
                    ? _vm.type
                        .split("-")
                        .map(function (c) {
                          return c[0].toUpperCase() + c.slice(1).toLowerCase()
                        })
                        .join(" ")
                    : ""
                ) +
                "\n                Planınızı Seçiniz\n            "
            ),
          ]),
          _vm._v(" "),
          !_vm.isAppsumo()
            ? _c("div", { staticClass: "plan-select-options" }, [
                _c("div", { staticClass: "plan-select-option" }, [
                  ["supsis", "whatsapp-business", "whatsapp"].includes(_vm.type)
                    ? _c(
                        "div",
                        {
                          staticClass: "plan-user-select",
                          staticStyle: { width: "max-content" },
                        },
                        [
                          _c("div", { staticClass: "option-title" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.type == "supsis"
                                    ? "Temsilci Sayınız"
                                    : [
                                        "whatsapp-business",
                                        "whatsapp",
                                      ].includes(_vm.type)
                                    ? "Kanal Sayısı"
                                    : ""
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "option-description" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.type == "supsis"
                                    ? "Maximun konuşacak temsilci sayısı"
                                    : [
                                        "whatsapp-business",
                                        "whatsapp",
                                      ].includes(_vm.type)
                                    ? "Whatsapp kanal sayısı"
                                    : ""
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          ["supsis"].includes(_vm.type)
                            ? _c(
                                "div",
                                { staticClass: "classic-counter-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "classic-counter-button decrease-button",
                                      on: {
                                        click: function ($event) {
                                          _vm.details.agentCount > 1 &&
                                            _vm.details.agentCount--
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                -\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("a-input-number", {
                                        staticClass:
                                          "counter counter-custom-input",
                                        attrs: { min: 1, max: 1000 },
                                        model: {
                                          value: _vm.details.agentCount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.details,
                                              "agentCount",
                                              $$v
                                            )
                                          },
                                          expression: "details.agentCount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "classic-counter-button increase-button",
                                      on: {
                                        click: function ($event) {
                                          _vm.details.agentCount++
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                +\n                            "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          ["whatsapp-business", "whatsapp"].includes(_vm.type)
                            ? _c(
                                "div",
                                { staticClass: "classic-counter-group" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "classic-counter-button decrease-button",
                                      on: {
                                        click: function ($event) {
                                          _vm.details.whatsappChannel > 1 &&
                                            _vm.details.whatsappChannel--
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                -\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("a-input-number", {
                                        staticClass:
                                          "counter counter-custom-input",
                                        attrs: { min: 1, max: 1000 },
                                        model: {
                                          value: _vm.details.whatsappChannel,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.details,
                                              "whatsappChannel",
                                              $$v
                                            )
                                          },
                                          expression: "details.whatsappChannel",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "classic-counter-button increase-button",
                                      on: {
                                        click: function ($event) {
                                          _vm.details.whatsappChannel++
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                +\n                            "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "option-title" }, [
                      _vm._v("Şunun için hesapla:"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-description" }, [
                      _vm._v("Avantajlı paket indirimleri!"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "plan-actions" },
                      [
                        _c("ChangePlan", {
                          model: {
                            value: _vm.localPeriod,
                            callback: function ($$v) {
                              _vm.localPeriod = $$v
                            },
                            expression: "localPeriod",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                !_vm.isWizard &&
                !_vm.trialInfo.trial &&
                _vm.type === "chatbot" &&
                _vm.currentPlan &&
                _vm.currentPlan.enabled
                  ? _c("div", { staticClass: "plan-select-option" }, [
                      _vm.type === "chatbot"
                        ? _c(
                            "div",
                            {
                              staticClass: "extra-package",
                              on: {
                                click: function ($event) {
                                  _vm.chatbotExtraPackageModal = true
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "material-icons" }, [
                                _vm._v("cake"),
                              ]),
                              _vm._v(
                                "\n                        Ekstra Paket\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("transition", { attrs: { name: "scale" } }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.localPlans.length > 4 && _vm.prevButton,
                      expression: "localPlans.length > 4 && prevButton  ",
                    },
                  ],
                  class: {
                    "scale-in": _vm.prevButton,
                    "scale-out": !_vm.prevButton,
                  },
                  attrs: { id: "prev-button" },
                  on: { click: _vm.previousPlan },
                },
                [
                  _c(
                    "md-icon",
                    { staticClass: "navigate-arrow navigate-left" },
                    [_vm._v("arrow_back_ios_new")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { ref: "supsisPlans", staticClass: "supsis-plans" },
              [
                _vm.teamGroupPlan
                  ? _c("Card", {
                      staticClass: "plan",
                      style: {
                        transform:
                          "translateX(-" + _vm.currentPlanIndex * 100 + "%)",
                      },
                      attrs: {
                        plan: _vm.teamGroupPlan,
                        "is-admin": _vm.isAdmin,
                        wizard: _vm.isWizard,
                        "is-group-plan": true,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(
                  _vm.localPlans.filter(function (plan) {
                    return _vm.type === "supsis" &&
                      (_vm.localPeriod !== "monthly" ||
                        _vm.details.agentCount > 1)
                      ? !plan.isFreePlan
                      : true
                  }),
                  function (plan, index) {
                    return _c("Card", {
                      key: plan._id,
                      staticClass: "plan",
                      style: {
                        transform:
                          "translateX(-" + _vm.currentPlanIndex * 100 + "%)",
                      },
                      attrs: {
                        plan: plan,
                        period: _vm.localPeriod,
                        details: _vm.details,
                        "appsumo-coupons": _vm.appsumoCoupons,
                        plans: _vm.allLocalPlans,
                        "current-plans": _vm.localCurrentPlans,
                        "is-admin": _vm.isAdmin,
                        wizard: _vm.isWizard,
                        "is-selected": _vm.isSelected(plan),
                      },
                      on: {
                        subscribe: _vm.onSubscribe,
                        unsubscribe: _vm.onUnSubscribe,
                      },
                    })
                  }
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "scale" } }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.localPlans.length > 4 && _vm.nextButton,
                      expression: "localPlans.length > 4 && nextButton",
                    },
                  ],
                  class: {
                    "scale-in": _vm.nextButton,
                    "scale-out": !_vm.nextButton,
                  },
                  attrs: { id: "next-button" },
                  on: { click: _vm.nextPlan },
                },
                [
                  _c(
                    "md-icon",
                    { staticClass: "navigate-arrow navigate-right" },
                    [_vm._v("arrow_forward_ios")]
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }